// Progi reguł generated insight (V1, rule-based — sekcja 9 specu). Spec nie definiuje wartości
// liczbowych, więc są tu do strojenia w jednym miejscu.
// All inputs are the ROUNDED percentages shown on the KPI cards, so the sentence and the cards agree.
const MARGINAL_PRESENCE_THRESHOLD = 5; // % — visibility AND cited below this: the brand is practically absent
const VISIBILITY_UNDER_CITED_MAX_VISIBILITY = 15; // % — below this, cited > visibility gets its own variant
const HIGH_VISIBILITY_THRESHOLD = 30; // % odpowiedzi z marką
// Coverage = % odpowiedzi z marką, w których cytowana jest też jej domena. Three levels, because the
// copy words are tied to the number shown right after them: "rarely" (< 20), "only some" (20–39),
// "often / regularly" (>= 40).
const MID_COVERAGE_THRESHOLD = 20;
const HIGH_COVERAGE_THRESHOLD = 40;

export type OverviewInsightVariant =
  | 'marginalPresence'
  | 'visibilityUnderCited'
  | 'highVisHighCoverage'
  | 'highVisMidCoverage'
  | 'highVisLowCoverage'
  | 'lowVisHighCoverage'
  | 'lowVisMidCoverage'
  | 'lowVisLowCoverage';

export const percentOf = (part: number, total: number): number =>
  total > 0 ? Math.round((part / total) * 100) : 0;

const coverageLevel = (coveragePct: number): 'High' | 'Mid' | 'Low' => {
  if (coveragePct >= HIGH_COVERAGE_THRESHOLD) return 'High';
  return coveragePct >= MID_COVERAGE_THRESHOLD ? 'Mid' : 'Low';
};

// First match wins. Two overrides, then a 2×3 matrix of visibility × own-source coverage.
// - marginalPresence: both shares below 5% — neither coverage nor the cited/visibility relation
//   carries information on a handful of responses.
// - visibilityUnderCited: the own domain is cited in MORE responses than the brand is mentioned
//   (spec §9 "Low Visibility + High Cited ratio"). Coverage never exceeds visibility, so without
//   this such a brand would read as "domains rarely cited". Limited to low visibility because the
//   copy says "rarely mentions"; above 15% the matrix texts (scoped to responses with the brand)
//   stay true whatever the cited level.
// - matrix: coverage (not the visibility − cited gap in pp) is the second axis in BOTH visibility
//   branches — a pp gap grew with visibility and could contradict the appended "coverage" sentence,
//   which shows this very number.
export const resolveOverviewInsightVariant = (
  visibilityPct: number,
  citedPct: number,
  coveragePct: number
): OverviewInsightVariant => {
  if (visibilityPct < MARGINAL_PRESENCE_THRESHOLD && citedPct < MARGINAL_PRESENCE_THRESHOLD) {
    return 'marginalPresence';
  }
  if (visibilityPct < VISIBILITY_UNDER_CITED_MAX_VISIBILITY && citedPct > visibilityPct) {
    return 'visibilityUnderCited';
  }
  const vis = visibilityPct >= HIGH_VISIBILITY_THRESHOLD ? 'high' : 'low';
  return `${vis}Vis${coverageLevel(coveragePct)}Coverage`;
};
